import { Loading, Table } from '@shape-ds/components';
import { useNotificationsListQuery } from 'queries/notifications/queries';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import useNotificationForm from 'components/Notifications/hooks/useNotificationForm';
import { useFeatureFlag } from '@shape/feature-flag';
import { EmptyMessage, buildColumnsObject } from '@shape/lighthouse-components';
import { notificationColumns } from './columnsConfig';
import { NotificationItem } from 'queries/notifications/contract';

const NotificationsTable: React.FC = () => {
  const { data, isLoading } = useNotificationsListQuery();
  const isWhatsAppEnabled = useFeatureFlag('feat-notifications-wpp');
  const { onSubmit, isMutating, formMethods, onEdit, editingId } = useNotificationForm();
  const { t } = useTranslation();

  const columns = buildColumnsObject<NotificationItem>({
    columns: notificationColumns(onEdit, editingId),
    getLabel: (key: string) => t(`components:notifications.columns.${key}`),
    overrideColumns: isWhatsAppEnabled
      ? ['asset', 'model_label', 'frequency', 'email', 'whatsapp', 'edit']
      : ['asset', 'model_label', 'frequency', 'edit'],
  });

  return (
    <FormProvider {...formMethods}>
      {(data ?? []).length > 0 && (!isLoading || !isMutating) ? (
        <form onSubmit={onSubmit}>
          <Table
            data={data ?? []}
            style={{ maxHeight: '300px', overflow: 'overlay' }}
            columns={columns}
            className="notifications-table"
          />
        </form>
      ) : (
        <EmptyMessage message={t('components:notifications.empty')} showIcon={false} />
      )}
      {(isLoading || isMutating) && <Loading center />}
    </FormProvider>
  );
};

export default NotificationsTable;
